import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"data-base"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 20H20.4863C19.2502 21.1648 15.9178 22 12 22C8.08221 22 4.74984 21.1648 3.51367 20H3V5C3 6.65685 7.02944 8 12 8C16.9706 8 21 6.65685 21 5V20Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M12 8C16.9706 8 21 6.65685 21 5C21 3.34315 16.9706 2 12 2C7.02944 2 3 3.34315 3 5C3 6.65685 7.02944 8 12 8Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 12C21 13.6569 16.9706 15 12 15C7.02944 15 3 13.6569 3 12M21 12V19C21 20.6569 16.9706 22 12 22C7.02944 22 3 20.6569 3 19V12M21 12V5M3 12V5M3 5C3 6.65685 7.02944 8 12 8C16.9706 8 21 6.65685 21 5M3 5C3 3.34315 7.02944 2 12 2C16.9706 2 21 3.34315 21 5","strokeWidth":"props.strokeWidth"}}]}]};

const DataBase = Vue.extend<IconProps>({
  name: 'DataBaseIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'data-base',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default DataBase;
